import React from 'react';

interface ToastProps {
  variant?: 'safe' | 'warn' | 'risk' | 'info';
  children: React.ReactNode;
  className?: string;
}

const ACCENT_BORDER: Record<NonNullable<ToastProps['variant']>, string> = {
  safe: 'border-l-safe',
  warn: 'border-l-warn',
  risk: 'border-l-risk',
  info: 'border-l-accent'
};

/**
 * App-standard toast: a `surface` card with a colored left accent border
 * matching the safe/warn/risk status tokens (see epic design_html `.toast`).
 */
export const Toast: React.FC<ToastProps> = ({ variant = 'info', children, className = '' }) => {
  return (
    <div
      role="status"
      className={`flex items-center gap-2 rounded-xl border border-line border-l-4 ${ACCENT_BORDER[variant]} bg-surface px-4 py-3 text-sm font-semibold text-ink shadow-lg ${className}`}
    >
      {children}
    </div>
  );
};
